import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'CampPass';

const CampPassesPassApi: any = baseApi(endpoint);

export default CampPassesPassApi;